<template>
  <div class="flex h-full w-full cursor-pointer ml-auto">
    <div
      class="w-1/2 h-full bg-expo_dblue menu_parent relative transition-all duration-300 hover:bg-expo_lblue border-r border-black"
      @click="handleClick('Online')"
    >
      <div
        class="h-14 w-full flex items-center justify-center transform bg-expo_green group-hover:rotate-90 transform"
      >
        <a ref="forOnline" class="hidden" :href="settings.cloud_url"></a>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="menu_icon transition-all duration-300 ease-in-out w-6 h-6"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M12 21a9.004 9.004 0 0 0 8.716-6.747M12 21a9.004 9.004 0 0 1-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 0 1 7.843 4.582M12 3a8.997 8.997 0 0 0-7.843 4.582m15.686 0A11.953 11.953 0 0 1 12 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0 1 21 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0 1 12 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 0 1 3 12c0-1.605.42-3.113 1.157-4.418"
          />
        </svg>
      </div>
      <h5 class="menu_title">Online Expo</h5>
    </div>

    <div
      class="w-1/2 h-full bg-expo_dblue menu_parent relative transition-all duration-300 hover:bg-expo_lblue border-r border-black"
      @click="handleClick('Schools')"
    >
      <div
        class="h-14 w-full flex items-center justify-center transform bg-expo_lblue group-hover:rotate-90 transform"
      >
        <a
          ref="forSchools"
          class="hidden"
          :href="settings.central_domain2_url + '/for-schools'"
        ></a>
        <img
          class="menu_icon transition-all duration-300 ease-in-out w-6"
          src="/img/schools-icon.png"
          alt="For Schools icon"
        />
      </div>
      <h5 class="menu_title">For Schools</h5>
    </div>

    <div
      class="w-1/2 h-full bg-expo_dblue menu_parent relative transition-all duration-300 hover:bg-expo_red"
      @click="handleClick('ForExhibitors')"
    >
      <div
        class="h-14 w-full flex items-center justify-center transform bg-expo_red group-hover:rotate-90 transform"
      >
        <a
          ref="forExhibitors"
          class="hidden"
          :href="settings.central_domain2_url + '/for-exhibitors'"
        ></a>
        <img
          class="menu_icon transition-all duration-300 ease-in-out w-6"
          src="/img/exhibitors-icon.png"
          alt="For Exhibitors icon"
        />
      </div>
      <h5 class="menu_title">For Exhibitors</h5>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { shared } from '../js/mixins/shared.js'

export default {
  mixins: [shared],

  props: {
    client: { default: false },
  },

  computed: {
    ...mapGetters({
      settings: 'shared/getSettings',
    }),
  },

  methods: {
    handleClick(request) {
      if (this.client !== 'client2') {
        if (request === 'Schools') {
          this.$refs.forSchools.click()
        } else if (request === 'ForExhibitors') {
          this.$refs.forExhibitors.click()
        }
      } else {
        if (request === 'Online') {
          this.$refs.forOnline.click()
        } else {
          this.$router.push({ name: request })
        }
      }
    },
  },
}
</script>

<style scoped>
.menu_title {
  position: absolute;
  color: #fff;
  font-family: Questrial;
  font-size: 18px;
  letter-spacing: 1px;
  top: 150px;
  left: -46px;
  height: var(--menu-width);
  width: 150px;
  -webkit-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  transform: rotate(90deg);
  pointer-events: none;
  -webkit-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all 0.3s ease;
}

.menu_parent:hover .menu_icon {
  -webkit-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  transform: rotate(90deg);
}
.menu_parent:hover .menu_title {
  -webkit-transform: rotate(90deg) translateX(20px);
  -ms-transform: rotate(90deg) translateX(20px);
  transform: rotate(90deg) translateX(20px);
}
</style>
